<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="1000px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => close()"
      destroy-on-close
      append-to-body
    >
      <div class="add-faric-dialog">
        <FabricTable :tableHeight="500" @chooseFabric="chooseFabric" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import FabricTable from '../fabric-table'
export default {
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '选择面料' },
  },
  components: { FabricTable },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    chooseFabric(data) {
      this.$emit('chooseFabric', data)
    }
  },
}
</script>
<style lang="scss" scoped>
.add-faric-dialog {
  padding: 10px 0 20px 0;
}
</style>
